import type { GameProductShort } from '@patrianna/shared-patrianna-types/store/GameModule'
import { useEffect } from 'react'

import { PARLAY_ROOM_CODES_GC, PARLAY_ROOM_CODES_SC } from 'config/parlay-rooms-codes'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { saveBingoProducts } from 'store/modules/bingo/actions'
import { getBingoProductsSelector } from 'store/modules/bingo/selectors'
import { getGamesByCategoryCode } from 'utils/loadGameInfoGetInitialProps'

const PARLAY_ROOM_CODES = [...PARLAY_ROOM_CODES_SC, ...PARLAY_ROOM_CODES_GC]

export default function useGetBingoProducts(): GameProductShort[] {
  const dispatch = useAppDispatch()
  const bingoProducts = useAppSelector(getBingoProductsSelector)

  useEffect(() => {
    if (bingoProducts.length > 0) {
      return
    }

    getGamesByCategoryCode([{ productCategoryCode: 'parlay' }])
      .then((response) => {
        const products = response?.categories?.at(0)?.products as GameProductShort[] | undefined

        if (!products?.length) {
          return
        }

        const parlayRooms = products.filter((game) => PARLAY_ROOM_CODES.includes(game.code))

        if (parlayRooms.length > 0) {
          dispatch(saveBingoProducts({ products: parlayRooms }))
        }
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== 'production') {
          console.error('[useGetBingoProducts]', error)
        }
      })
  }, [dispatch, bingoProducts.length])

  return bingoProducts
}
